import { createStore, applyMiddleware } from 'redux';
import { config } from './config';
import Logger from 'redux-logger';
import reduxThunk from 'redux-thunk';
import reducers from './reducers';

var store = undefined;

export default {
    init() {
        let createStoreWithMiddleware;
        if (config.LOGGER == 1 || window.localStorage.getItem('logger')) {
            createStoreWithMiddleware = applyMiddleware(reduxThunk, Logger)(createStore);
        } else {
          createStoreWithMiddleware = applyMiddleware(reduxThunk)(createStore);
        }
        if (process.env.NODE_ENV === 'development') {
          store = createStoreWithMiddleware(reducers, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()); 
        } else {
          store = createStoreWithMiddleware(reducers);
        }
        return store;
    },
    getStore(){
        return store;
    }
}